import { ORDER } from "~/common/constants";
import { InvitationLink } from "~/common/types/invitationLink";
import {
  ConsultationLinkResponse,
  UpsertConsultationLinkRequest,
} from "~/providers/types/invitations";
import { api } from "./axios";

export interface ConsultationLinksParams {
  organizationId: string;
  orderBy?: keyof ConsultationLinkResponse;
  order?: (typeof ORDER)[keyof typeof ORDER];
}

export interface ConsultationLinksWithInvitationParams extends ConsultationLinksParams {
  invitationId?: string;
}

export const listInvitationLinks = async ({
  organizationId,
  orderBy = "label",
  order = ORDER.ascendant,
}: ConsultationLinksParams) => {
  const response = await api.get<InvitationLink[]>(
    `/v1/organizations/${organizationId}/invitation-links`,
    {
      params: {
        order,
        order_by: orderBy,
      },
    },
  );

  return response.data;
};

export const deleteInvitationLink = async ({
  organizationId,
  invitationId,
}: ConsultationLinksWithInvitationParams) => {
  if (!invitationId) return;

  const response = await api.delete<void>(
    `/v1/organizations/${organizationId}/invitation-links/${invitationId}`,
  );

  return response.data;
};

export const activateInvitationLink = async ({
  organizationId,
  invitationId,
}: ConsultationLinksWithInvitationParams) => {
  if (!invitationId) return;

  const response = await api.post<void>(
    `/v1/organizations/${organizationId}/invitation-links/${invitationId}/activate`,
  );

  return response.data;
};

export const deactivateInvitationLink = async ({
  organizationId,
  invitationId,
}: ConsultationLinksWithInvitationParams) => {
  if (!invitationId) return;

  const response = await api.post<void>(
    `/v1/organizations/${organizationId}/invitation-links/${invitationId}/deactivate`,
  );

  return response.data;
};

export const createNewConsultationLink = async ({
  organization_id,
  ...payload
}: UpsertConsultationLinkRequest) => {
  const response = await api.post<ConsultationLinkResponse>(
    `/v1/organizations/${organization_id}/invitation-links`,
    payload,
  );
  return response.data;
};

export const updateConsultationLink = async ({
  organization_id,
  link_id,
  ...payload
}: UpsertConsultationLinkRequest) => {
  const response = await api.put<ConsultationLinkResponse>(
    `/v1/organizations/${organization_id}/invitation-links/${link_id}`,
    payload,
  );
  return response.data;
};
